export const styles = theme => ({

	root: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-evenly',
		margin: '20px 0',
	},

});

export default styles;